import {
    ReactNode,
    useEffect,
    useRef,
    useState,
} from "react";
import { useLocation } from "react-router-dom";

import { NetworkErrorBoundary, NetworkModeBar } from "@/components";
import { NetworkModeEnum } from "@/enums";

export const NetworkProvider = ({ children } : { children: ReactNode }) => {
    const [networkMode, setNetworkMode] = useState(NetworkModeEnum.CONNECTED);

    const [hasOfflineNavigation, setHasOfflineNavigation] = useState(false);

    const {
        pathname,
        search,
    } = useLocation();

    const currentPath = `${pathname}${search}`;

    const prevPathRef = useRef(currentPath);

    useEffect(
        () => {
            if (networkMode === NetworkModeEnum.OFFLINE && currentPath !== prevPathRef.current) setHasOfflineNavigation(true);

            prevPathRef.current = currentPath;
        },
        [networkMode, currentPath],
    );

    useEffect(
        () => {
            window.addEventListener(
                NetworkModeEnum.OFFLINE.toLowerCase(),
                () => setNetworkMode(NetworkModeEnum.OFFLINE),
            );
            window.addEventListener(
                NetworkModeEnum.ONLINE.toLowerCase(),
                () => setNetworkMode(NetworkModeEnum.ONLINE),
            );

            return () => {
                window.removeEventListener(
                    NetworkModeEnum.OFFLINE.toLowerCase(),
                    () => setNetworkMode(NetworkModeEnum.OFFLINE),
                );

                window.removeEventListener(
                    NetworkModeEnum.ONLINE.toLowerCase(),
                    () => setNetworkMode(NetworkModeEnum.ONLINE),
                );
            };
        },
        [],
    );

    useEffect(
        () => {
            if (networkMode === NetworkModeEnum.ONLINE) {
                setTimeout(
                    () => setNetworkMode(NetworkModeEnum.CONNECTED),
                    3000,
                );

                setHasOfflineNavigation(false);
            }
        },
        [networkMode],
    );

    return (
        <>
            <NetworkModeBar mode={networkMode} />
            <NetworkErrorBoundary hasOfflineNavigation={hasOfflineNavigation}>{children}</NetworkErrorBoundary>
        </>
    );
};
